export const getClientOS = (): 'WINDOWS' | 'MAC' | 'LINUX' | 'UNKNOWN' => {
    const userOS = navigator.userAgent.toLowerCase();
    if (userOS.includes('win')) return 'WINDOWS';
    if (userOS.includes('mac')) return 'MAC';
    if (userOS.includes('linux')) return 'LINUX';
    return 'UNKNOWN';
};
